import React, { useEffect } from 'react';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import MessageForm from 'component/organism/workflow/forms/message/MessageForm';
import { FormikProvider, useFormik } from 'formik';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { isEqual } from 'lodash';
const MessageModal = ({ isOpen, onClose, title, id, isError }) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    setIsChanged,
    initialWorkflowData,
    isChanged,
  } = useWorkflowContext();
  const formik = useFormik({
    initialValues: {
      message: selectedNode?.message?.message || '',
      messageVariant:
        selectedNode?.message?.variant?.length > 0
          ? selectedNode?.message?.variant?.map((item) => item.messageVariant)
          : selectedNode?.message?.messageVariant?.length > 0
          ? selectedNode?.message?.messageVariant
          : [],
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      message: Yup.string().required('Required'),
      messageVariant: Yup.array().of(Yup.string().required('Required')),
    }),
    onSubmit: (values, { resetForm }) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);
      if (initialNode) {
        const { variant, message } = initialNode?.message || {};
        const initialMessageObject = {
          messageVariant: variant || [],
          message: message || '',
        };
        const currentValues = values;
        const changed = !isEqual(currentValues, initialMessageObject);

        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }

          return prev;
        });
      }
    },
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                message: formik.values,
                is_Error: isError,
              }
            : node
        );
        setWorkflowData((prev) => {
          return {
            ...prev,
            nodes: updatedNodes,
          };
        });
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <MessageForm id={id} />
      </FormikProvider>
    </RightSlider>
  );
};

export default MessageModal;
